(function() {
  function getPolishTime() {
    // Get current time in Polish timezone
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Warsaw',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      weekday: 'short',
      hour12: false
    });
    
    const parts = formatter.formatToParts(now);
    const hour = parseInt(parts.find(p => p.type === 'hour').value);
    const minute = parseInt(parts.find(p => p.type === 'minute').value);
    const second = parseInt(parts.find(p => p.type === 'second').value);
    
    // Get day of week from formatted parts
    const weekdayShort = parts.find(p => p.type === 'weekday').value;
    const weekdayMap = { 'Sun': 0, 'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6 };
    const dayOfWeek = weekdayMap[weekdayShort] || 0;
    
    // Return object with time components and day
    return { hour, minute, second, dayOfWeek };
  }

  function updateTimer() {
    const container = document.getElementById('maszyna-jolanta-container');
    if (!container) return;

    const timerText = document.getElementById('shipping-timer-text');
    const timerCountdown = document.getElementById('shipping-timer-countdown');
    const timerTomorrow = document.getElementById('shipping-timer-tomorrow');
    const timerHours = document.getElementById('timer-hours');
    const timerMinutes = document.getElementById('timer-minutes');
    const timerSeconds = document.getElementById('timer-seconds');
    const tomorrowText = document.getElementById('shipping-tomorrow-text');

    const polishTime = getPolishTime();
    const currentHour = polishTime.hour;
    const currentMinute = polishTime.minute;
    const currentSecond = polishTime.second;
    const dayOfWeek = polishTime.dayOfWeek; // 0 = Sunday, 6 = Saturday

    // Check if it's Saturday (6) or Sunday (0)
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      // Weekend - show "Wysyłka już w poniedziałek"
      if (timerText) timerText.style.display = 'none';
      if (timerCountdown) timerCountdown.style.display = 'none';
      if (timerTomorrow) timerTomorrow.style.display = 'block';
      if (tomorrowText) tomorrowText.textContent = 'Wysyłka już w poniedziałek';
    } else {
      // Target time: 13:00:00
      const targetHour = 13;
      const targetMinute = 0;
      const targetSecond = 0;

      // Calculate time until 13:00
      let hoursLeft = targetHour - currentHour;
      let minutesLeft = targetMinute - currentMinute;
      let secondsLeft = targetSecond - currentSecond;

      if (secondsLeft < 0) {
        secondsLeft += 60;
        minutesLeft--;
      }
      if (minutesLeft < 0) {
        minutesLeft += 60;
        hoursLeft--;
      }
      if (hoursLeft < 0) {
        hoursLeft += 24;
      }

                        // Check if it's after 13:00
                        if (currentHour >= targetHour) {
                          // Show only "Wysyłka już jutro" or "Wysyłka już w poniedziałek" - hide everything else
                          if (timerText) timerText.style.display = 'none';
                          if (timerCountdown) timerCountdown.style.display = 'none';
                          if (timerTomorrow) timerTomorrow.style.display = 'block';
                          // If it's Friday (5) after 13:00, show Monday message
                          if (dayOfWeek === 5) {
                            if (tomorrowText) tomorrowText.textContent = 'Wysyłka już w poniedziałek';
                          } else {
                            if (tomorrowText) tomorrowText.textContent = 'Wysyłka już jutro';
                          }
                        } else {
        // Show timer and text only if before 13:00
        if (timerText) timerText.style.display = 'flex';
        if (timerCountdown) timerCountdown.style.display = 'flex';
        if (timerTomorrow) timerTomorrow.style.display = 'none';

        // Update countdown
        if (timerHours) timerHours.textContent = String(hoursLeft).padStart(2, '0');
        if (timerMinutes) timerMinutes.textContent = String(minutesLeft).padStart(2, '0');
        if (timerSeconds) timerSeconds.textContent = String(secondsLeft).padStart(2, '0');
      }
    }
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateTimer();
      setInterval(updateTimer, 1000);
    });
  } else {
    updateTimer();
    setInterval(updateTimer, 1000);
  }
})();


